import { render, staticRenderFns } from "./starred.vue?vue&type=template&id=bcae077a&scoped=true&"
import script from "./starred.vue?vue&type=script&lang=js&"
export * from "./starred.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcae077a",
  null
  
)

export default component.exports